export default __webpack_public_path__ + "bullet-point.cb8e32.png";